import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

/**
 * 🔹 Payload para crear/actualizar
 */
export interface TipoPuntoPayload {
  descripcion: string;
  estado?: number;
}

/**
 * 🔹 Entidad
 */
export interface TipoPunto {
  id?: number;
  descripcion: string;
  estado: number;
  fechaCreacion?: string;
  fechaModificacion?: string;
}

/**
 * 🔹 Respuesta genérica
 */
export interface TipoPuntoResponse {
  id?: number;
  message?: string;
  error?: string;
  data?: any;
  [key: string]: any;
}

@Injectable({
  providedIn: "root",
})
export class TipoPuntoService {
  private readonly apiUrl = `${environment.apiUrl}/api/tipo_punto`;

  constructor(private http: HttpClient) {}

  /**
   * Obtener todos los tipos de punto
   */
  getAll(): Observable<TipoPunto[]> {
    return this.http.get<TipoPunto[]>(this.apiUrl, {
      withCredentials: true,
    });
  }

  /**
   * Obtener tipo de punto por ID
   */
  getById(id: number): Observable<TipoPunto> {
    return this.http.get<TipoPunto>(
      `${this.apiUrl}/${id}`,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Crear tipo de punto
   */
  create(
    payload: TipoPuntoPayload
  ): Observable<TipoPuntoResponse> {
    return this.http.post<TipoPuntoResponse>(
      this.apiUrl,
      payload,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Actualizar tipo de punto
   */
  update(
    id: number,
    payload: Partial<TipoPuntoPayload>
  ): Observable<TipoPuntoResponse> {
    return this.http.put<TipoPuntoResponse>(
      `${this.apiUrl}/${id}`,
      payload,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Eliminar tipo de punto
   */
  remove(id: number): Observable<any> {
    return this.http.delete<any>(
      `${this.apiUrl}/${id}`,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Inactivar tipo de punto
   */
  inactivar(id: number): Observable<TipoPuntoResponse> {
    return this.http.put<TipoPuntoResponse>(
      `${this.apiUrl}/${id}/inactivar`,
      {},
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Activar tipo de punto
   */
  activar(id: number): Observable<TipoPuntoResponse> {
    return this.http.put<TipoPuntoResponse>(
      `${this.apiUrl}/${id}/activar`,
      {},
      {
        withCredentials: true,
      }
    );
  }
}